import ActionTypes from 'redux/ActionTypes';

const initialState = {
    itemList : [],
    selectedItem : {},
    fetchExchange: true,
}

const exchange = (state = initialState, { type, payload }) => {
	switch (type) {
		case ActionTypes.SET_DATA_EXCHANGE:
			return { ...state, [payload.key]: payload.data };
		default:
			return state;
	}
};

export default exchange;